import { IOriginCoupon } from './coupon';

export interface ICampaignInit {
    title: string;
    begin_time: string;
    end_time: string;
    pre_time: string;
    support_pre: number;
    sale_price: number;
    stock: number;
    left_stock: number;
    max_buy_times: number;
    has_buy_num: number;
    current_time: string;
    coupon: number;
    stype: number | ECampaignType;
    campaign_id: string;
    sku_min_price: number;
    sku_max_price: number;
    full_discount: Array<IFullDiscount>;
    select_shop_full_discount: Array<IFullDiscount>; // 满足的店铺满减条件，只有一个
    tips?: string;
}

export enum ECampaignType {
    FullDiscount = 100,
    FullDiscountWithMultiShop = 110,
    LimitTimeSkill = 3
}

export interface ICampaignConfig {
    supportGiveUpActivity: boolean; // 是否支持放弃活动
    supportStyleInGoodsList: boolean; // 是否支持在商品列表页面展示相应的活动样式
    campaignScene: {
        // 活动的适用场景
        toutiao: boolean; // 头条app
        toutiaoProduct: boolean; // 头条的app，不包括头条app
        weixin: boolean; // 微信
        outapp: boolean; // 站外（除微信）
    };
    notifyBarStyle: number; // 默认预告条样式
    campaignBarStyle: number; // 默认活动条
    percent: number; // 已购买百分比
    isPre: boolean; // 是否在预告中，只有当支持预告才可靠
    customChecker: () => boolean;
    needRefresh: boolean; // 预告需要刷新
    needPreEndTime: boolean; // 是否需要预热结束时间
    extraFunc: (item: ICampaignInit) => Partial<ICampaignConfig>; // 活动预处理
    url: string; // 跳转活动页url
    urlParams: Record<string, string>; // 跳转活动页需要携带的参数
    urlName: string; // 跳转活动页的名字
    promotionString: string; // 营销文案
    beginTime: Date;
    endTime: Date;
    preTime: Date | '';
    currentTime: Date;
    name: string;
    waitForSale: boolean;
    bigFullSmall: Array<IFullDiscount>;
    canUseCoupon: boolean;
    descPrefix?: string; // 用于标签前缀
    descSuffix?: string;
}

export interface IFullDiscount {
    discount: number;
    full: number;
    per_level: number;
}

export interface IDiscountDetail {
    total_amount: number;
    coupon_amount: number;
    coupon_info: IOriginCoupon;
    full_discount_amount: number;
    full_discount_info: ICampaignInit;
    per_level: boolean;
}

export type ICampaign = ICampaignConfig & ICampaignInit;
